export default {"src":"/_next/static/media/arrow_right_gray.3181c98c.svg","height":14,"width":9};